<template>
    <div class="ssEmuLinkMst">
        <div class="form1">
        <el-form :model="addForm" ref="addForm" label-width="120px"
            :inline="false" class="demo-ruleForm" size="mini">
            <el-form-item label="模拟器内部名CD" prop="ssemuinnamecd">
                <el-input v-model="addForm.ssemuinnamecd"></el-input>
            </el-form-item>
            <el-form-item label="游戏机系统" prop="sssystemcd">
                <el-input v-model="addForm.sssystemcd"></el-input>
            </el-form-item>
        </el-form>
        <el-form :inline="true"> 
            <el-form-item class="as_btn">
                <el-button type="primary" @click="submitForm('addForm')" :disabled="btnFlag">保存</el-button>
                <el-button @click="resetForm()">重置</el-button>
            </el-form-item>
        </el-form>
        </div>
        <el-table :data="tableData" stripe style="width: 100%" size="mini" border>
            <el-table-column prop="ssemuinnamecd" label="SSEMUINNAMECD" > </el-table-column>
            <el-table-column prop="sssystemcd" label="SSSYSTEMCD" > </el-table-column>
        <el-table-column label="操作" width="180">
            <template slot-scope="scope">
                <el-button size="mini"  @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
            </template>
        </el-table-column>
    </el-table>
    <el-dialog
            title="⚠警告"
            :visible.sync="dialogVisible2"
            width="30%">
            <span>刪除系统关连({{ row.ssemuinnamecd +"  -  " + row.sssystemcd}})需要提供刪除序列號！</span>
            <el-form :inline="true" label-width="120px" ref="seq"> 
                <el-form-item label="序列號" prop="seq">
                    <el-input v-model="addForm.seq"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible2 = false;">取 消</el-button>
                <el-button type="primary" @click="dialogVisible2 = false;dodelete()">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
  name: 'ssEmuLinkMst',
  data(){
    return {
      addForm:{
          ssemuinnamecd:'',//模拟器内部名CD
          sssystemcd:'',//模拟器内部名
          seq:''
      },
      seq: {seq:''},
      row:{},
      dialogVisible2:false,
      tableData: [],
      btnFlag:false,
    };
  },
  props: {
    msg: String
  },
  methods:{
    resetForm() {//重置表单
        for (const key in this.addForm) {
            this.addForm[key] = '';
        }
        this.addForm.ssemuinnamecd = this.$route.query.ssemuinnamecd;
    },
    submitForm(formName) {//提交表单
        this.$refs[formName].validate((valid) => {
            if (valid) {
                let _this = this;
                _this.btnFlag = true;
                this.$axios.post('/ssBaseController/addEmuLink.do',{..._this.addForm,})
                .then(res => {  //res是返回结果
                    // console.log(res)
                    _this.addForm.ssemuinnamecd = res.ssemuinnamecd;
                    _this.addForm.sssystemcd = '';
                    _this.tableData = res.ssList;
                    _this.$message({//消息提示框
                        message: '保存成功',
                        type: 'success',
                        showClose: true,//是否有关闭按钮
                        duration: 1000 //持续时间
                    });
                    _this.btnFlag = false;
                }).catch(err => { _this.btnFlag = false;console.error(err); })
            } else {
                console.error('error submit!!');
                return false;
            }
        });
    },
    getList(param){
        let _this = this;
        this.$axios.post('/ssBaseController/jumpEmuLink.do',param)
        .then(res => {  //res是返回结果
            // console.log(res)
            _this.addForm.ssemuinnamecd = res.eumInNameCd;
            _this.tableData = res.ssList;

        })
    },
    handleEdit(index, row){
        this.addForm.ssemuinnamecd = row.ssemuinnamecd
        this.addForm.sssystemcd = row.sssystemcd
        // console.log(index);
    },
    handleDelete(index, row){
        // handleEdit(index, row)
        this.row = row;
        this.dialogVisible2 = true;
        // console.log(index);
    },
    dodelete(){
        let _this = this;
        this.btnFlag = true;
        this.handleEdit(-1, this.row)
        this.$axios.post('/ssBaseController/deleteEmuLink.do',{..._this.addForm,})
        .then(res => {
            _this.$message({ message: res, type: 'success', showClose: true, duration: 1000});
            _this.btnFlag = false;
            setTimeout(() => {
                _this.getList(_this.$route.query)
            }, 1000);
        })
        .catch(err => {
            console.error('服务器连接失败', err);
            _this.btnFlag = false;
        });
    }
  },
  created:function () {//组件实例化之后执行，页面尚未显示
    this.getList(this.$route.query);
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.ssEmuLinkMst{
  height:100%;
  width:1500px;
  margin: 0 auto;
  display:flex;
  justify-content: center;
  align-items: left;
  flex-direction:column;
}
.form1{
    width:360px;
    text-align: center;
}
</style>
